import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

type EmptyStateProps = {
  icon: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
};

export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div className={cn("flex flex-col items-center justify-center gap-3 px-6 py-12 text-center", className)}>
      <span className="flex size-12 items-center justify-center rounded-full bg-surface-muted text-muted">
        <Icon className="size-6" aria-hidden="true" />
      </span>
      <div className="font-semibold">{title}</div>
      {description && <p className="max-w-sm text-muted">{description}</p>}
      {action}
    </div>
  );
}
